//isIterable() could be any Iterable including IterableIterator.
export const isIterable = <T>(v: unknown): v is Iterable<T> =>
  //note: v != null is not strict comparison (ie v !== null)
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  v != null && typeof v[Symbol.iterator] === 'function';

export const isIterableIterator = <T>(v: unknown): v is IterableIterator<T> =>
  //note: v != null is not strict comparison (ie v !== null)
  v != null &&
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  typeof v[Symbol.iterator] === 'function' &&
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  typeof v.next === 'function';

//isIterator() could be any Iterator
//including:
//* AsyncIterator (result of next() is a promise, but can't tell without executing it)
//* IterableIterator
//* AsyncIterableIterator.
//eslint-disable-next-line
export const isIterator = <T>(v: unknown): v is Iterator<T> =>
  //note: v != null is not strict comparison (ie v !== null)
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  v != null && typeof v.next === 'function';

//isAsyncIterable() could be any AsyncIterable including AsyncIterableIterator.
//eslint-disable-next-line
export const isAsyncIterable = <T>(v: unknown): v is AsyncIterable<T> =>
  //note: v != null is not strict comparison (ie v !== null)
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  v != null && typeof v[Symbol.asyncIterator] === 'function';

//eslint-disable-next-line
export const isAsyncIterableIterator = <T>(
  v: unknown,
): v is AsyncIterableIterator<T> =>
  //note: v != null is not strict comparison (ie v !== null)
  v != null &&
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  typeof v[Symbol.asyncIterator] === 'function' &&
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  typeof v.next === 'function';
